export default {
  label: "In Entwicklung",
  notAvailable: "noch nicht verfügbar",
};
